import React, { useMemo } from "react";
import Table from "./Table";
import { useSelector } from "react-redux";
import { getPrizeRank } from "../store/userBuyInLogsSlice";
import AnimationNumber from "./AnimationNumber";

function PoolRewards() {
  const prizeRank = useSelector(getPrizeRank);

  const cols = useMemo(() => {
    return [
      {
        key: "name",
        col: 4,
        format: (val: string | number) => (
          <div className="d-flex gap-2 align-items-center">
            <div>{val}</div>
          </div>
        ),
      },
      {
        key: "prize",
        col: 7,
        className: "justify-content-end px-3",
        format: (val: string | number) => <AnimationNumber value={val ?? 0} />,
      },
    ];
  }, []);
  const groups = useMemo(() => {
    return prizeRank.prizeRank;
  }, [prizeRank.prizeRank]);

  const poolAmount = useMemo(
    () => prizeRank.totalReward ?? 0,
    [prizeRank.totalReward]
  );

  return (
    <div className="position-relative">
      <div id="group-table" className="row pb-4 position-relative">
        <div className="col d-flex align-items-center justify-content-center position-relative">
          <img
            alt="pool-light"
            src="/assets/rewards-light.png?v=1"
            className="position-absolute start-50 translate-middle-x"
            style={{ width: "120%", bottom: 0 }}
          />
          <img
            alt="pool"
            src="/assets/pool-reward-sign.png"
            className="position-absolute start-50 top-50 translate-middle"
            style={{ height: "90%" }}
          />
          <div className="pool-rewards">
            <span>
              <AnimationNumber value={poolAmount} />
            </span>
          </div>
        </div>
        <div className="col me-3" style={{ fontSize: "2.75rem" }}>
          <div className="position-relative text-center mb-2">
            <img
              src="/assets/title_frame.png"
              alt="prize-frame"
              style={{ height: "10rem" }}
            />
            <div
              className="position-absolute start-50 top-50 translate-middle fw-bold text-title"
              style={{ fontSize: "2rem" }}
            >
              TOTAL PRIZE
            </div>
          </div>
          <Table
            // header={group.name}
            items={groups}
            cols={cols}
            // titles={titles}
          />
        </div>
      </div>
    </div>
  );
}

export default PoolRewards;
